import {memo} from 'react';

import styled from 'styled-components';

import {pushRoute} from '~/shared/router';
import {ActiveOrderState} from '~/shared/store/models';
import {flexCenterVertically} from '~/shared/theme/FlexLayout';
import {flipOnLTR, rotateOnLTR} from '~/shared/theme/flipOnLTR';
import {body13Bold, body14Normal} from '~/shared/theme/typography';
import {MenuEventsProps, useMenuList} from '~/common/hooks/UserTransactions';
import {Arrow} from '~/shared/components/UserTransactions/components/styled';
import SideMenu from '~/shared/components/UserTransactions/components/SideMenu';

const SubheaderRow = styled.div`
  width: 100%;
  height: 40px;
  background-color: ${({theme}) => theme.userReport.showOrder.subHeaderBackground};
  color: ${({theme}) => theme.userReport.showOrder.text};
  ${body13Bold};
`;

const BackToUserReportButton = styled.div`
  color: ${({theme}) => theme.userReport.showOrder.text};
`;

const CustomMobileWrapper = styled.div`
  padding: 0 15px;
  align-self: center;
  justify-content: space-between;
  height: 100%;
  ${flexCenterVertically};
  flex: 1;
`;

const CustomArrow = styled(Arrow)<{forward: boolean}>`
  width: 10px;
  display: block;
  ${flipOnLTR`
    right: 0;
    left: auto;
  `}
  ${rotateOnLTR}
`;

const Label = styled.div`
  ${body14Normal};
  ${flipOnLTR`margin-right: 15px;`}
`;

type SubheaderProps = {
  order: ActiveOrderState;
  onMenuClick: (id?: number) => void;
  openedRowMenuId?: number;
  menuActions: MenuEventsProps;
  baseUrl: string;
  backButtonText: string;
};

const Subheader = ({order, menuActions, openedRowMenuId, onMenuClick, baseUrl, backButtonText}: SubheaderProps) => {
  const menuList = useMenuList(order, menuActions);
  return (
    <SubheaderRow>
      <CustomMobileWrapper>
        <BackToUserReportButton onClick={() => pushRoute(baseUrl, {keepAllQueries: false})}>
          <CustomArrow noAlt forward />
          <Label>{backButtonText}</Label>
        </BackToUserReportButton>
        <SideMenu
          menuList={menuList}
          isMobile
          order={order}
          onClick={onMenuClick}
          openedRowMenuId={openedRowMenuId}
          {...menuActions}
        />
      </CustomMobileWrapper>
    </SubheaderRow>
  );
};

export default memo(Subheader);
